import {
  format,
  setYear,
  setMonth,
  setDate
} from 'date-fns'
import Parse from 'parse'

const state = {
  user: new Parse.User(),
  username: '',
  email: '',
  name: '',
  password: '',
  tel: '',
  birthDay: new Date(),
  country: null,
  prefecture: null,
  address: ''
}

const getters = {
  address: (state, getters, rootState, rootGetters) => {
    return rootGetters['text/trim'](state.address)
  },

  birthDay: (state, getters, rootState) => {
    let style = (rootState.locale.current === 'en') ? 'YYYY / M / D' : 'YYYY年 M月D日'
    return format(state.birthDay, style)
  },

  isBlank: (state) => {
    return state.email === ''
      || state.name === ''
      || state.password === ''
      || state.tel === ''
      || state.address === ''
  }
}

const mutations = {
  setUser (state, user) {
    state.user = user
  },

  setUsername (state, username) {
    state.username = username
  },

  setEmail (state, email) {
    state.email = email
  },

  setName (state, name) {
    state.name = name
  },

  setPassword (state, password) {
    state.password = password
  },

  setTel (state, tel) {
    state.tel = tel
  },

  setBirthDay (state, birthDay) {
    state.birthDay = birthDay
  },

  setBirthDayYear (state, year) {
    state.birthDay = setYear(state.birthDay, year)
  },

  setBirthDayMonth (state, month) {
    state.birthDay = setMonth(state.birthDay, month)
  },

  setBirthDayDate (state, date) {
    state.birthDay = setDate(state.birthDay, date)
  },

  setAddress (state, address) {
    state.address = address
  },

  setCountry (state, country) {
    state.country = country
  },

  setPrefecture (state, prefecture) {
    state.prefecture = prefecture
  }
}

const actions = {
  async fetchUser ({ commit }) {
    const loginUser = Parse.User.current()
    const query = new Parse.Query('_User')
    query.include('country', 'prefecture')
    const user = await query.get(loginUser.id)
    commit('setUser', user)
  },

  resetAttrs ({ state, commit }) {
    const user = state.user
    commit('setUsername', user.get('email'))
    commit('setEmail', user.get('email'))
    commit('setName', user.get('name'))
    commit('setTel', user.get('tel'))
    commit('setBirthDay', user.get('birthDay'))
    commit('setCountry', user.get('country'))
    commit('setPrefecture', user.get('prefecture'))
    commit('setAddress', user.get('address'))
  },

  async signUp ({ state, dispatch }) {
    const user = state.user
    user.set('username', state.email)
    user.set('email', state.email)
    user.set('password', state.password)
    user.set('name', state.name)
    user.set('tel', state.tel)
    user.set('birthDay', state.birthDay)
    user.set('country', state.country)
    user.set('prefecture', state.prefecture)
    user.set('address', state.address)

    try {
      const result = await state.user.signUp()
      Parse.Cloud.run('setAdminACL', { id: result.id })
      Parse.Cloud.run('setAdminRole', { id: result.id })
      dispatch('locale/save', null, { root: true })
    }
    catch(error) {
      if (error.code === 125) {
        return "exceptionInvalidEmailAddress"
      } else if (error.code === 202) {
        return "exceptionEmailTaken"
      } else {
        return "exceptionInternalServerError"
      }
    }
  },

  async saveName ({ state }) {
    const user = state.user
    user.set('name', state.name)
    await user.save()
  },

  async saveLoginInfo ({ state }) {
    const user = state.user
    user.set('email', state.email)
    user.set('username', state.email)
    if (state.password !== '') {
      user.set('password', state.password)
    }
    await user.save()
  },

  async saveTel ({ state }) {
    const user = state.user
    user.set('tel', state.tel)
    await user.save()
  },

  async saveCountry ({ state }) {
    const user = state.user
    user.set('country', state.country)
    await user.save()
  },

  async savePrefecture ({ state }) {
    const user = state.user
    user.set('prefecture', state.prefecture)
    await user.save()
  },

  async saveAddress ({ state }) {
    const user = state.user
    user.set('address', state.address)
    await user.save()
  },

  async saveBirthDay ({ state }) {
    const user = state.user
    user.set('birthDay', state.birthDay)
    await user.save()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
